import { Alert, Typography } from '@mui/material';
import React,{ useMemo, useState } from 'react';
import { Button, CheckboxField, Modal } from 'src/shared/ui/elements';

export const DeleteAvailability = ({
  $title = 'Delete Bulk Availability',
  $message,
  $onConfirm,
  $loading,
  $confirmBtnText = "Remove",
  $cancelBtnText = 'Cancel',
  $maxWidth = "40rem",
  franchises = [],
  ...props
}) => {

  const coachFranchises = useMemo(()=>{
   const unsortedFranchises = franchises.map(f=>({
      ...f,
      disabled: !f?.settings?.canManageAvailability
    })) || [];	
    return unsortedFranchises.sort((a, b) => {
    if (a.disabled === b.disabled) {
        return a.name.localeCompare(b.name);
    }
    return a.disabled - b.disabled;
  });
  },[franchises])
  const [selectedFranchises, setSelectedFranchises] = useState(coachFranchises?.filter(f=>!f.disabled)?.map((franchise) => franchise.id)||[]);

  const handleCheckboxChange = (franchiseId) => {
    setSelectedFranchises((prevSelected) =>
      prevSelected.includes(franchiseId)
        ? prevSelected.filter((id) => id !== franchiseId)
        : [...prevSelected, franchiseId]
    );
  };

  
  const handleConfirm = async () => {
    await $onConfirm(selectedFranchises);
    props.$actions.close();
  };

  
const showCheckboxes = useMemo(() => {
    //show checkboxes if atleast one of the franchise allow coaches to manage their availability
     return franchises.some(
    (f) => f?.settings?.canManageAvailability
  );
   }, [
    franchises
  ]) 
  return (
    <Modal $title={$title} style={{ maxWidth: $maxWidth }} {...props}>
      <Modal.Content>
        {showCheckboxes ?
          <Alert severity='error'>
            
            <span>{$message}</span>
            {coachFranchises?.length > 1 &&
              <div className=''>
                <p className="tw-font-semibold tw-mb-1">Select franchise to delete availability</p>
                {coachFranchises.map((franchise) => (
                  <div key={franchise.id} className="tw-flex tw-mb-1 tw-items-center">
                    <CheckboxField
                      disabled={franchise.disabled}
                      className="tw-items-start tw-accent-red"
                      labelClassName ="tw-text-[#5f2120] tw-mb-0"
                      $label={franchise?.disabled ? (
                        <span>
                          {" "}
                          {franchise.name} (Please contact your manager to update your availability)
                        </span>
                      ) : (
                          <span >{ franchise.name}</span>
                      )}
                      checked={selectedFranchises.includes(franchise.id)}
                      onChange={() => handleCheckboxChange(franchise.id)}
                    />
              
                    {/* <label>{franchise.name}</label> */}
                  </div>
                ))}
              </div>
            }
          </Alert> :
          (<Alert severity="info">
              <Typography variant="body1">Please contact your manager to update your availability</Typography>
          </Alert>
          )}
        
      </Modal.Content>

      <Modal.Footer className="flex align-center justify-flex-end">
        {showCheckboxes &&
          <Button type="button" className="tw-bg-red tw-border-red" $loading={$loading} onClick={handleConfirm} disabled={!selectedFranchises.length > 0} >
            {$confirmBtnText}
          </Button>
        }
        <Button className="ml-12 outline tw-text-red tw-border-red" onClick={props.$actions.close} type="button">
          {$cancelBtnText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
